const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
import styled from 'astroturf/react'
import { connect } from 'react-redux'

import { isEmbeddedSelector, isInlineEmbedSelector } from 'selectors/embed'
import _Layout from "Layout.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/index.js?styleId=Layout";



const Layout = /*#__PURE__*/styled('div', null, {
  displayName: "Layout",
  styles: _Layout,
  attrs: props => ({
    ...props,
    'data-booking-layout': true
  })
})

const mapStateToProps = (state) => ({
  isNotEmbedded: !isEmbeddedSelector(state),
  isNotInlineEmbed: !isInlineEmbedSelector(state)
})

export default connect(mapStateToProps, {})(Layout)
